import React from "react";
import { component_tool, utils_tool } from "@/tool";
import { WizTableForm } from '@/containers/common';

let { WizModal, WizCard, WizPopover } = component_tool;
let { $$, checkStrLength } = utils_tool;
import moment from "moment";
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

//配置项
let componentName = 'comment';
let ref;
let refAlone;
let refLookDetail;
const columns = (data) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "评价内容",
      name: "searchContent",
      dataIndex: "searchContent",
      searchItem: {}
    },
    {
      title: "姓名",
      name: "commentFullName",
      tableItem: {},
    },
    {
      title: "账号",
      name: "commentUserName",
      tableItem: {},
    },
    {
      title: "昵称",
      name: "commentNickName",
      tableItem: {},
    },
    {
      title: "评价内容",
      name: "content",
      tableItem: {},
    },
    {
      title: "星评",
      name: "score",
      dataIndex: "score",
      tableItem: {
        render: (text, record) => (
          <>{ record && record.score!=null && record.score!=0 ? record.score+'星':'' }</>
        ),
      },
      dict: [
        { code: 1, codeName: "1星" },
        { code: 2, codeName: "2星" },
        { code: 3, codeName: "3星" },
        { code: 4, codeName: "4星" },
        { code: 5, codeName: "5星" }
      ],
      searchItem: {
        type: "select"
      },
    },

    {
      title: "姓名",
      name: "searchCommentFullName",
      dataIndex: "searchCommentFullName",
      searchItem: {}
    },
    {
      title: "账号",
      name: "searchCommentUserName",
      dataIndex: "searchCommentUserName",
      searchItem: {}
    },
    {
      title: "昵称",
      name: "searchCommentNickName",
      dataIndex: "searchCommentNickName",
      searchItem: {}
    },
    {
      title: "手机号",
      name: "commentMobile",
      tableItem: {},
    },
    {
      title: "身份证号/工号",
      name: "commentIdCard",
      tableItem: {},
    },
    {
      title: "状态",
      name: "commentState",
      dict: [
        { code: 1, codeName: "激活" },
        { code: 0, codeName: "禁用" }
      ],
      tableItem: {},
    },
    {
      title: "用户属性",
      name: "commentUserType",
      dict: [
        { code: 0, codeName: "学员" },
        { code: 1, codeName: "SGM总部" },
        { code: 2, codeName: "SGM区域" },
        { code: 3, codeName: "供应商" }
      ],
      tableItem: {},
    },
    {
      title: "评价时间",
      name: "commentTime",
      tableItem: {
        width: 150,
        render: (text, record) => (
          <>{ record && record.commentTime ? formatterDate(record.commentTime):'' }</>
        ),
      },
    }
  ]
};

const templateConfig = (data) => {
  const { onSelect, _btnLookUserFun, _this } = data;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref && ref.getSelectRows(rows)
  };
  let initRows = () => {
    return _this.state.selectedStudentProgramEvaluationRows
  };

  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(data),
        btnAccessCheck:false,
        searchBarProps: {
          // collapse: false,
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort: [],
          buttons: []
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
          onSelect: _onSelect,
          rowSelection: {
            getCheckboxProps: (record) => {
              return { disabled: record['state'] !== 1 };
            },
          },
          needOnRowSelect: (record, index) => {
            return record['state'] === 1
          },
        },
        rowOperateSort: ['viewProgramEvaluation', 'lookUser'],
        rowOperateView: [
          {
            key: "viewProgramEvaluation",
            custom: true,
            params: {  children: '查看' },
            customOnClick: {
              key: "modal",
              params: {
                modalKey:'viewProgramEvaluation_'+new Date().getTime(),
                modalParams: {
                  title: "课程评论详情",
                  diy: (e) => {
                    e.record = Object.assign({},e.record)
                    return(
                      <div>{e.record.content && e.record.content}</div>
                    )
                  },
                  footer:null,
                  width: 600
                }
              },
              formatParams: (rows, record, filter) => {
                return { ...record };
              }
            }
          },
          {
            key: "lookUser",
            name: "WizButton",
            params: {
              children: "查看任职",
              key: "_btnUser",
            },
            onClick: e => _btnLookUserFun && _btnLookUserFun(e),
          }
        ],
        commonOperate: {
          add: false,
          delete: false,
          look: false
        }
      }
    }
  };
};

const apis = (data) => {
  const { bizIdList } = data;
  return {
    list: {
      path: `${componentName}/commentMarkDetailPageList`,
      payload: {
        key: `${componentName}@commentMarkDetailPageList`,
        apiParams: { pageNum: 1, pageSize: 10,  bizIdList,bizType: 0 }
      }
    }
  }
};


let reduxTemplateConfig = (args) => {
  const { programId } = args;
  return {
    apis: apis({ bizIdList:[programId],bizType: 0}),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
